<template>
    <AppActionBase icon-url="/assets/icons/Delete.svg" alt="Delete" :custom-class="`btn-delete-style ${customClass}`"
        v-bind="$attrs" @click="$emit('click', $event)" />
</template>

<script>
import AppActionBase from './AppActionBase.vue';

export default {
    name: 'AppActionDelete',
    components: {
        AppActionBase
    },
    props: {
        customClass: {
            type: String,
            default: ''
        }
    },
    emits: ['click']
}
</script>